// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/vue-multiselect/dist/vue-multiselect.min.css
// module id = 239
// module chunks = 1